// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3e03fe66","703":"7b844e12"}[chunkId] + ".chunk.js";
};